import React from 'react';

import LoadingBar from 'components/LoadingBar';
import { SLoadingContainer } from './styled';

type Props = {
  text: string;
};

const ModalLoader = ({ text }: Props) => (
  <SLoadingContainer data-test="version-control-modal-loader">
    {text}
    <LoadingBar color="blue" />
  </SLoadingContainer>
);

export default ModalLoader;
